import { BodyText, Flex } from 'modules/ui';
import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';

export const LinksWrapper = styled(Flex)`
  width: 100%;
  ${mediaQuery('md')} {
    max-width: 16.25rem;
  }

  ${BodyText} {
    margin-bottom: 0;
  }
`;

export const ButtonLinks = styled(Flex)`
  flex-direction: row;
  align-items: center;
  width: 100%;

  > :first-child {
    flex: 1 1 0;
    margin-right: 0.563rem;
  }

  > :last-child {
    height: auto;
    min-height: 2.25rem;
  }
`;

export const PageContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${mediaQuery('md')} {
    flex-direction: row;
  }
`;

export const StyledNavigationFlex = styled(Flex)`
  width: 100%;
  margin-bottom: 2.5rem;

  ${mediaQuery('md')} {
    width: 19.25rem;
    min-width: 19.25rem;
  }
`;

export const StyledComponentFlex = styled(Flex)`
  width: 100%;

  ${mediaQuery('md')} {
    width: 100%;
  }
`;
